import { supabase } from "./supabaseClient";

// Sign up
export const signUp = async (email, password) => {
  const { data, error } = await supabase.auth.signUp({ email, password });
  return { data, error };
};

// Sign in
export const signIn = async (email, password) => {
  const { data, error } = await supabase.auth.signInWithPassword({ email, password });
  return { data, error };
};

// Sign out
export const signOut = async () => {
  try {
    // Use local scope to avoid global logout 403s when refresh/session tokens are missing.
    const { error } = await supabase.auth.signOut({ scope: "local" });

    // Treat missing-session as already signed out so UI can proceed cleanly.
    if (error && (error.name === "AuthSessionMissingError" || /session missing/i.test(error.message || ""))) {
      return { error: null };
    }

    return { error };
  } catch (error) {
    if (error && (error.name === "AuthSessionMissingError" || /session missing/i.test(error.message || ""))) {
      return { error: null };
    }
    return { error };
  }
};

// Get current user session
export const getCurrentUser = async () => {
  // Prefer local session lookup to avoid hanging on network.
  const { data, error } = await supabase.auth.getSession();
  return { data: { user: data?.session?.user ?? null, session: data?.session ?? null }, error };
};

// Set role in user metadata (e.g., "scout" or "coach")
export const setUserRole = async (role) => {
  const { data, error } = await supabase.auth.updateUser({ data: { role } });
  return { data, error };
};
export const setOrgRole = async (role) => {
  const { data, error } = await supabase.auth.updateUser({ data: { orgrole: role } });
  return { data, error };
};
